module.exports = __webpack_public_path__ + "static/media/campaign-icon.504dbfc4.svg";